/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFloatNone = createReactComponent("float-none", "IconFloatNone", [
  [
    "path",
    {
      d: "M4 5m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M4 15l16 0", key: "svg-1" }],
  ["path", { d: "M4 19l16 0", key: "svg-2" }]
]);

export { IconFloatNone as default };
//# sourceMappingURL=IconFloatNone.js.map
